import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
const CONNECTIVITY_QUORUM = {
    minFailures: 3,
    minElapsedMs: 10000
};
const CONFIRMATION = {
    firstCheckSeconds: [
        2,
        5,
        10
    ],
    thenEverySeconds: 5
};
export const DEFAULT_CONNECTIVITY_STATE = {
    status: 'reachable',
    consecutiveFailures: 0,
    firstFailureAt: null
};
const REACHED_ANCHOR_OUTCOMES = [
    'success',
    'clientError',
    'serverError'
];
export const provesAnchorReached = (outcome)=>REACHED_ANCHOR_OUTCOMES.includes(outcome);
const hasReachedQuorum = (consecutiveFailures, firstFailureAt, now)=>consecutiveFailures >= CONNECTIVITY_QUORUM.minFailures && now - firstFailureAt >= CONNECTIVITY_QUORUM.minElapsedMs;
const applyTransportFailure = (state, now)=>{
    var _state_firstFailureAt;
    if (state.status === 'unreachable') {
        return state;
    }
    const consecutiveFailures = state.consecutiveFailures + 1;
    const firstFailureAt = (_state_firstFailureAt = state.firstFailureAt) !== null && _state_firstFailureAt !== void 0 ? _state_firstFailureAt : now;
    if (hasReachedQuorum(consecutiveFailures, firstFailureAt, now)) {
        return {
            status: 'unreachable',
            unreachableSince: now
        };
    }
    return _object_spread_props(_object_spread({}, state), {
        consecutiveFailures,
        firstFailureAt
    });
};
export const applyRequestOutcome = (state, outcome, now)=>{
    if (provesAnchorReached(outcome)) {
        return DEFAULT_CONNECTIVITY_STATE;
    }
    if (outcome === 'transportFailure') {
        return applyTransportFailure(state, now);
    }
    return state;
};
export const declareOutage = (state, now)=>state.status === 'unreachable' ? state : {
        status: 'unreachable',
        unreachableSince: now
    };
export const isOutageSuspected = (state)=>state.status === 'reachable' && state.consecutiveFailures > 0;
const isConfirmationCheckDue = (seconds)=>{
    const lastScheduled = CONFIRMATION.firstCheckSeconds[CONFIRMATION.firstCheckSeconds.length - 1];
    return seconds > lastScheduled ? (seconds - lastScheduled) % CONFIRMATION.thenEverySeconds === 0 : CONFIRMATION.firstCheckSeconds.includes(seconds);
};
export const startConfirmationChecks = (startTicker, check)=>{
    const elapsed = {
        seconds: 0
    };
    return startTicker(()=>{
        elapsed.seconds += 1;
        if (isConfirmationCheckDue(elapsed.seconds)) check();
    });
};
export const outageTransition = (previous, next)=>{
    if (previous.status === 'reachable' && next.status === 'unreachable') {
        return {
            kind: 'lost',
            since: next.unreachableSince
        };
    }
    if (previous.status === 'unreachable' && next.status === 'reachable') {
        return {
            kind: 'restored'
        };
    }
    return null;
};
export function connectivityRestoredEvent(ended, now) {
    return {
        type: 'connectivity_restored',
        page_name: 'app_shell',
        hierarchy: [],
        entity_type: 'connectivity',
        entity_name: 'connectivity_restored',
        duration_ms: now.getTime() - ended.since,
        trigger: ended.trigger
    };
}
export const checkAnchor = (probeReachability)=>probeReachability().then(()=>'success', (error)=>new ErrorResponse(error).classifyRequestFailure());
